import { useState } from 'react';
import { useSavePreisToolSupplierTerms } from '@/api/preis-tool/preis-tool.hooks';
import { DsAlert, DsButton, DsInput, DsModal } from '@/modules/internal-v2/ds';
import { fmtEUR, parsePriceInput } from '../helpers';

interface ShippingCostDialogProps {
  supplierBpId: number;
  supplierName: string;
  current: number | null;
  onClose: () => void;
}

/**
 * Shipping cost of one supplier (EOS-56). It is one value per supplier and
 * shows on every offer of that supplier, for every article.
 */
export function ShippingCostDialog({ supplierBpId, supplierName, current, onClose }: ShippingCostDialogProps) {
  const save = useSavePreisToolSupplierTerms();
  const [value, setValue] = useState(current == null ? '' : fmtEUR(current));
  const [error, setError] = useState<string | null>(null);

  const submit = () => {
    const parsed = value.trim() === '' ? null : parsePriceInput(value);
    if (value.trim() !== '' && (parsed == null || parsed < 0)) {
      return setError('Bitte einen Betrag ab 0 angeben oder das Feld leeren.');
    }
    setError(null);
    save.mutate({ supplierBpId, shippingCost: parsed }, { onSuccess: onClose });
  };

  return (
    <DsModal
      open
      onClose={onClose}
      title="Versandkosten"
      description={`${supplierName} · gilt für alle Angebote dieses Lieferanten`}
      footer={
        <>
          <DsButton variant="ghost" onClick={onClose} disabled={save.isPending}>
            Abbrechen
          </DsButton>
          <DsButton variant="primary" onClick={submit} disabled={save.isPending}>
            {save.isPending ? 'Speichern…' : 'Speichern'}
          </DsButton>
        </>
      }
    >
      <div className="pt-form">
        {(error ?? (save.isError ? 'Die Versandkosten konnten nicht gespeichert werden.' : null)) && (
          <DsAlert severity="error">
            {error ?? 'Die Versandkosten konnten nicht gespeichert werden.'}
          </DsAlert>
        )}
        <label className="pt-field">
          <span className="pt-label">Versandkosten netto je Bestellung (€)</span>
          <DsInput
            mono
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') submit();
            }}
            placeholder="leer = unbekannt"
            inputMode="decimal"
            autoFocus
          />
        </label>
      </div>
    </DsModal>
  );
}
